import { FieldBase, IFieldOptions } from './field-base.interface'

export class GroupField extends FieldBase<any> {
  controlType = 'group'
  fields: FieldBase<any>[] = []

  constructor(
    options: IFieldOptions<any> = {},
    fields: FieldBase<any>[] = [],
  ) {
    super(options)

    this.fields = fields
  }
}
